import { View } from "react-native-web";
import { CImage } from "../../../components/atoms";
import { Constants, Images } from "../../../config";

export const aparthotelFilterCriteria = (isMobileVersion, styles) => {
  return [
    {
      title: "Location",
      isHide: isMobileVersion,
      isLocation: true,
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_STATUS,
      icon: Images.iconTagStatus,
      width: 20,
      height: 20,
      title: "Status",
      isHide: true,
      detailList: [
        {
          id: 1,
          label: "Open",
          tagId: 1,
        },
        {
          id: 2,
          label: "Closed",
          tagId: 2,
        },
        {
          id: 3,
          label: "Temporarily Closed",
          tagId: 4,
        },
        {
          id: 4,
          label: "Permanently Closed",
          tagId: 3,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_APARTHOTEL_CATEGORY,
      icon: Images.iconTagEventType,
      width: 20,
      height: 20,
      title: "Category",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "Basic",
          tagId: 6801,
        },
        {
          id: 2,
          label: "Premium",
          tagId: 6802,
        },
        {
          id: 3,
          label: "Luxury",
          tagId: 6803,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_APARTHOTEL_PRICE,
      icon: Images.iconTagPrice,
      width: 20,
      height: 20,
      title: "Price",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "$",
          tagId: 6901,
        },
        {
          id: 2,
          label: "$$",
          tagId: 6902,
        },
        {
          id: 3,
          label: "$$$",
          tagId: 6903,
        },
        {
          id: 4,
          label: "$$$$",
          tagId: 6904,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_APARTHOTEL_FEATURE,
      icon: Images.iconTagFeature,
      width: 20,
      height: 20,
      title: "Features",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "Kitchen",
          tagId: 7001,
        },
        {
          id: 2,
          label: "Washer",
          tagId: 7002,
        },
        {
          id: 3,
          label: "Dryer",
          tagId: 7003,
        },
        {
          id: 4,
          label: "Gym",
          tagId: 7004,
        },
        {
          id: 5,
          label: "Pool",
          tagId: 7005,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_STAR,
      icon: Images.iconTagStar,
      width: 20,
      height: 20,
      title: "Stars",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "1",
          tagId: 7101,
        },
        {
          id: 2,
          label: "2",
          tagId: 7102,
        },
        {
          id: 3,
          label: "3",
          tagId: 7103,
        },
        {
          id: 4,
          label: "4",
          tagId: 7104,
        },
        {
          id: 5,
          label: "5",
          tagId: 7105,
        },
        {
          id: 6,
          label: "N/A",
          tagId: 7106,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_RATING,
      icon: Images.iconTagRating,
      width: 21.5,
      height: isMobileVersion ? 21 : 20,
      title: "Rating",
      isHide: true,
      isRating: true,
      detailList: [
        {
          id: 1,
          label: "1",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating1}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 2,
          label: "2",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating2}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 3,
          label: "3",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating3}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 4,
          label: "4",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating4}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 5,
          label: "5",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating5}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
      ],
      selectedList: [],
    },
  ];
};
